import FeatherIcon from "feather-icons-react";
import React from "react";

export function goToHomePage(navigate) {
  navigate("/home");
}

export function allAreEqual(array) {
  const result = array.every(element => {
    if (element === array[0]) {
      return true;
    }
  });

  return result;
}

export function isEmail(str) {
  const s = String(str ?? "").trim();
  if (s.length === 0 || s.length > 254) return false;

  const at = s.indexOf("@");
  if (at <= 0 || at !== s.lastIndexOf("@")) return false;

  const local = s.slice(0, at);
  const domain = s.slice(at + 1).toLowerCase();

  if (local.length === 0 || local.length > 64) return false;
  if (local.startsWith(".") || local.endsWith(".")) return false;
  if (local.includes("..")) return false;
  if (!/^[A-Za-z0-9!#$%&'*+/=?^_`{|}~.-]+$/.test(local)) return false;

  if (!domain.includes(".") || domain.startsWith(".") || domain.endsWith(".")) return false;
  if (domain.includes("..")) return false;

  const labels = domain.split(".");
  for (const label of labels) {

    if (label.length === 0 || label.length > 63) return false;
    if (!/^[A-Za-z0-9-]+$/.test(label)) return false;
    if (label.startsWith("-") || label.endsWith("-")) return false;
  }

  const tld = labels[labels.length - 1];
  if (!/^[A-Za-z]{2,}$/.test(tld)) return false;

  if (domain === "gsml" || domain.startsWith("gsml.")) return false;
  const BAD_TLDS = new Set(["coom", "comm", "commm", "con", "cim", "vom"]);
  if (BAD_TLDS.has(tld)) return false;

  return true;
}


export function icons() {
  return (<div className={"service-card-icon mr-3"}>
    <FeatherIcon
      className={"txt-green"}
      icon="user"
    />
  </div>)
}

export function getLevel(roleId){
  if (roleId >= 1 && roleId <= 9) {
    return "Super Level"
  } else if (roleId >= 10 && roleId <= 99) {
    return "Account Level"
  } else if (roleId >= 100 && roleId <= 999) {
    return "Corporate Level"
  } else if (roleId >= 1000 && roleId <= 9999) {
    return "Level I"
  } else if (roleId >= 10000 && roleId <= 99999) {
    return "Level II"
  }else{
    return ""
  }
}

export const services = [
  {
    name: "UMS",
    version: " ",
    status: "Checking...",
    popupLink: "agri.senzmate.com/service/swagger-ui.html#",
    apiEndpoint: "/ums/info",
  },
];
